/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/User/UserB2B',[
    'jquery',
    'global/all',
    './UserB2B.Service',
    './UserB2B.Forms',
    'global/Pagination',
    'global/PaginationPendingSubUser'

], function ($, Roc, B2BService, Forms, PaginationSubUsers, PaginationPendingSubUser) {
    'use strict';
    var apiUrl = window.RocConfig.api.baseRocApiUrl;

    var pendingUsersPagination;
    var subUsersPagination;

    var subUsersViewModel = {};
    var pendingUsersViewModel = {};
    var totalPages = 1;

    var btns = {
        addSubUser: '[data-roc-action="addSubUser"]',
        editUser: '[data-roc-action="updateUser"]',
        removeUser: '[data-roc-action="removeUser"]',
        removePendingUser: '[data-roc-action="removePendingUser"]',
        resendInvitation: '[data-roc-action="resendInvitation"]',
    };

    /* events   */

    function addSubUserEvt() {
        $(document)
            .off('click', btns.addSubUser)
            .on('click', btns.addSubUser, function () {

                var isValid = Roc.Validation.validateForm(Forms.AddSubUser);
                var permissions = [];
                $('.b2b-permission').each(function () {
                    permissions.push({
                        code: $(this).attr('data-code'),
                        isEnabled: $(this).is(':checked')
                    });
                });

                if (isValid) {
                    Roc.Core.lockButton(btns.addSubUser);
                    var request = Roc.Validation.getFieldValues(Forms.AddSubUser);
                    request.permissions = permissions;
                    B2BService
                        .addSubUser(request)
                        .done(function () {
                            Roc.UI.success('Completed!');
                            window.location.replace('/my-account/');
                        }).fail(function (xhr) {
                            Roc.UI.ajaxErrorPopup(xhr);
                            Roc.Core.releaseLockedButton(btns.addSubUser);
                        });
                }
                return false;
            });
    }

    function editSubUserEvt() {
        $(document)
            .off('click', btns.editUser)
            .on('click', btns.editUser, function () {

                var permissions = [];
                $('.b2b-permission').each(function () {
                    permissions.push({
                        code: $(this).attr('data-code'),
                        isEnabled: $(this).is(':checked')
                    });
                });

                var request = {
                    subUserId: $(this).attr('data-user-id'),
                    permissions: permissions
                };

                Roc.Core.lockButton(btns.editUser);

                B2BService
                    .editSubUser(request)
                    .done(function () {
                        Roc.UI.success('Completed!');
                        window.location.replace('/my-account/');
                    }).fail(function (xhr) {
                        Roc.UI.ajaxErrorPopup(xhr);
                        Roc.Core.releaseLockedButton(btns.editUser);
                    });
                return false;
            });
    }

    function removeUserEvt() {
        $(document)
            .off('click', btns.removeUser)
            .on('click', btns.removeUser, function () {

                var userId = $(this).attr('data-user-id');
                Roc.UI.confirm('Are you sure you want to remove this user from this organization?', function () {
                    B2BService
                        .removeUser(userId)
                        .done(function () {
                            Roc.UI.success('Completed!');
                            window.location.replace('/my-account/');
                        }).fail(function (xhr) {
                            Roc.UI.ajaxErrorPopup(xhr);
                        });
                });
                return false;
            });
    }

    function removePendingUserEvt() {
        $(document)
            .off('click', btns.removePendingUser)
            .on('click', btns.removePendingUser, function () {

                var userId = $(this).attr('data-user-id');
                Roc.UI.confirm('Are you sure you want to remove this pending user?', function () {
                    B2BService
                        .removePendingUser(userId)
                        .done(function () {
                            Roc.UI.success('Completed!');
                            window.location.replace('/my-account/');
                        }).fail(function (xhr) {
                            Roc.UI.ajaxErrorPopup(xhr);
                        });
                });
                return false;
            });
    }

    function reSendActivationEmailEvt() {
        $(document)
            .off('click', btns.resendInvitation)
            .on('click', btns.resendInvitation, function () {
                var userId = $(this).attr('data-user-id');
                B2BService
                    .resendActivationRequest(userId)
                    .done(function () {
                        Roc.UI.success('Completed!');
                    }).fail(function (xhr) {
                        Roc.UI.ajaxErrorPopup(xhr);
                    });

                return false;
            });
    }

    function bindEvents() {
        addSubUserEvt();
        editSubUserEvt();
        removePendingUserEvt();
        reSendActivationEmailEvt();
    }

    /* sub users list   */

    function bindSubUsersWidget(viewModel) {
        if (viewModel) {
            Roc.UI.template('subUsers-Tmp', viewModel).then(function (renderedTemplate) {
                $('#subUsers table tbody').replaceWith(renderedTemplate);
            });

            subUsersPagination = PaginationSubUsers.updatePaging(viewModel);
        }
    }

    function reloadSubUsersWidget(pg) {
        if (typeof pg == 'undefined') {
            pg = subUsersPagination;
        }

        $.get(
            apiUrl + '/api/b2b/organization/subUsers/' + pg.pageSize + '/' + pg.page,
            function (data) {
                Roc.Logger.info('UserB2B -> reloadSubUsersWidget');
                Roc.Logger.info(data);
                bindSubUsersWidget(data);
            });
    }


    function initSubUsersWidget(model) {
        subUsersViewModel = model || {};
        if (subUsersViewModel.pagination) {
            subUsersPagination = PaginationSubUsers.init({
                page: subUsersViewModel.pagination.page,
                pageSize: subUsersViewModel.pagination.pageSize,
                totalPages: initTotalPages(subUsersViewModel.pagination.totalPages),
                prefix: '#subUsers'
            }, reloadSubUsersWidget);
        }
        removeUserEvt();
    };

    /* pending sub users list   */

    function bindPendingUsersWidget(viewModel) {
        if (viewModel) {
            Roc.UI.template('pendingSubUsers-Tmp', viewModel).then(function (renderedTemplate) {
                $('#pendingSubUsers table tbody').replaceWith(renderedTemplate);
            });

            pendingUsersPagination = PaginationPendingSubUser.updatePaging(viewModel);
        }
    }

    function reloadPendingUsersWidget(pg) {
        if (typeof pg == 'undefined') {
            pg = pendingUsersPagination;
        }

        $.get(
            apiUrl + '/api/b2b/organization/pending-subUsers/' + pg.pageSize + '/' + pg.page,
            function (data) {
                Roc.Logger.info('UserB2B -> reloadPendingUsersWidget');
                Roc.Logger.info(data);
                bindPendingUsersWidget(data);
                removePendingUserEvt();
                reSendActivationEmailEvt();
            });
    }

    function initPendingUsersWidget(model) {
        pendingUsersViewModel = model || {};
        if (pendingUsersViewModel.pagination) {
            pendingUsersPagination = PaginationPendingSubUser.init({
                page: pendingUsersViewModel.pagination.page,
                pageSize: pendingUsersViewModel.pagination.pageSize,
                totalPages: initTotalPages(pendingUsersViewModel.pagination.totalPages),
                prefix: '#pendingSubUsers'
            }, reloadPendingUsersWidget);
        }
        removePendingUserEvt();
        reSendActivationEmailEvt();
    };

    /* public members */

    function init() {
        bindEvents();
    }

    function initTotalPages(pages) {

        if (pages > totalPages) {
            totalPages = pages;
        }
        return totalPages;
    }


    var UserB2B = {
        init: init,
        initSubUsersWidget: initSubUsersWidget,
        initPendingUsersWidget: initPendingUsersWidget,
        viewModel: subUsersViewModel
    };

    Roc.Logger.debug('UserB2B.js Loaded:', UserB2B);

    return UserB2B;
});
